import { useFormik } from "formik";
import { V3Button } from "../Button";
import { V3Loader } from "../Loader";
import { V3BodyGrey35, RightAlignPanel } from "../ReusableStyledComponents";
import { V3TextInput } from "../TextInput/V3TextInput";
import { V3ModalBase } from "../V3ModalBase";
import { VerticalSpacing } from "../VerticalSpacing";

interface V3ModalPublicPasswordContentProps {
    onSubmit: (data: { password: string }) => void;
    isFetching: boolean;
}

export const V3ModalPublicPasswordContent = ({ onSubmit, isFetching }: V3ModalPublicPasswordContentProps) => {
    const formik = useFormik<{ password: string }>({
        enableReinitialize: true,
        initialValues: {
            password: ""
        },
        onSubmit: async (data) => {
            onSubmit(data);
        }
    });

    return (
        <V3ModalBase isOpen onClose={() => {}} title="Password protected content">
            <VerticalSpacing bottom={12}>
                <V3BodyGrey35>This resource is password protected</V3BodyGrey35>
            </VerticalSpacing>
            <form onSubmit={formik.handleSubmit}>
                <V3TextInput
                    label="Password"
                    name="password"
                    placeholder="insert password"
                    onChange={formik.handleChange}
                    type="password"
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                    error={formik.errors.hasOwnProperty("password") && formik.touched.hasOwnProperty("password") ? formik.errors.password : undefined}
                />
                <VerticalSpacing top={24}>
                    <RightAlignPanel>
                        {isFetching ? (
                            <V3Loader height={42} />
                        ) : (
                            <>
                                <div>
                                    <V3Button text="Confirm" type="submit" />
                                </div>
                            </>
                        )}
                    </RightAlignPanel>
                </VerticalSpacing>
            </form>
        </V3ModalBase>
    );
};
